import { TextStyle, InsetSize, InlineChildrenAlignment } from '@doordash/design-language';
export { IconType as ListCellIconType, InsetSize as ListCellInsetSize, Spacing as ListCellSpacing, TextAlignment as ListCellTextAlignment, TextColor as ListCellTextColor } from '@doordash/design-language';

var ListCellIconAlignment = InlineChildrenAlignment;
var ListCellSecondaryTitleAlignment = InlineChildrenAlignment;
var ListCellTextVerticalAlignment = InlineChildrenAlignment;
var CellStyles = {
  SmallToggled: {
    title: TextStyle.ListRowTitleSelected,
    subtext: TextStyle.ListRowSubtextSelected,
    secondaryTitle: TextStyle.ListRowSecondarySelected
  },
  Small: {
    title: TextStyle.ListRowTitle,
    subtext: TextStyle.ListRowSubtext,
    secondaryTitle: TextStyle.ListRowSecondary
  },
  LargeToggled: {
    title: TextStyle.ListRowTitleLargeSelected,
    subtext: TextStyle.ListRowSubtextLargeSelected,
    secondaryTitle: TextStyle.ListRowSecondaryLargeSelected
  },
  Large: {
    title: TextStyle.ListRowTitleLarge,
    subtext: TextStyle.ListRowSubtextLarge,
    secondaryTitle: TextStyle.ListRowSecondaryLarge
  }
};
var CONTENT_ROW = 2;
InsetSize.Small;

export { CONTENT_ROW, CellStyles, ListCellIconAlignment, ListCellSecondaryTitleAlignment, ListCellTextVerticalAlignment };
